import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

// Redux
import { connect } from 'react-redux';

// Components
import RoomForm from '../../../../components/RoomForm';

// Constants
import { DEFAULT } from '../../../../constants';
import PageHeader from '../../../../components/PageHeader';

class CreateRoom extends Component {

  constructor(props) {
    super(props);

    this.state = {
      redirectToRooms: false
    };
  }

  render() {
    return this.state.redirectToRooms || !this.props.setupMode ? <Redirect to='/admin/rooms' /> : (
      <>
        <PageHeader title='Create a Room' />
        <RoomForm onSuccess={() => this.setState({ redirectToRooms: true })} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  statusColor: state.status.schoolStatus ? state.status.schoolStatus.getColor() : DEFAULT,
  isMobile: state.ui.isMobile,
  isFullWidth: state.ui.isFullWidth,
  setupMode: state.setupMode.mode || state.setupMode.isLoading
});

export default connect(mapStateToProps, null)(CreateRoom);

CreateRoom.propTypes = {
  clearErrors: PropTypes.func,
  statusColor: PropTypes.object,
  isMobile: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  setupMode: PropTypes.bool.isRequired
};
